import {createUseStyles} from 'react-jss';
import MediaQueries from '../../style-helper/MediaQueries';

export default createUseStyles({
  DetailedTooltip: {
    [MediaQueries.phone]: {
      display: 'none',
    },
    background: '#fff',
    border: 'solid 1px #ccc',
    borderRadius: 2,
    filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))',
    display: 'block',
    position: 'absolute',
    width: 378,
    zIndex: '1',
    right: -20,
    top: '50%',
    transform: 'translateY(-50%) translateX(100%)',
    padding: [16, 20],
    
    '&:after': {
      content: '""',
      height: 20,
      width: 20,
      backgroundColor: '#fff',
      position: 'absolute',
      top: '50%',
      right: '100%',
      left: -11,
      marginTop: -10,
      transform: 'rotate(45deg)',
      borderLeft: [1, 'solid', '#ccc'],
      borderBottom: [1, 'solid', '#ccc'],
    },
  },
  DetailedTooltipTitle: {
    textAlign: 'center',
    marginBottom: 20,
    fontSize: 16,
    lineHeight: '1.5',
  },
  
});
